export enum ORDER_STATUS {
    pending = 1,
    changed = 2,
    vendor_accepted = 3,
    kitchen_accepted = 4,
    direct_confirm = 5,
    is_draft = 6,
}

export enum STOCK_ACTIONS {
    add = 1,
    deduct = 2,
    inventory = 3,
}

export const SHIFTS = [
    {
        id: 1,
        title: "صبح",
    },
    {
        id: 2,
        title: "عصر",
    },
];

export enum EXPAND_LIST_DAILY_TYPE {
    b2c = 1,
    b2b = 2,
    total = 3,
}

export const MONTHES = [
    {
        id: 1,
        title: "فروردین ماه",
    },
    {
        id: 2,
        title: "اردیبهشت ماه",
    },
    {
        id: 3,
        title: "خرداد ماه",
    },
    {
        id: 4,
        title: "تیر ماه",
    },
    {
        id: 5,
        title: "مرداد ماه",
    },
    {
        id: 6,
        title: "شهریور ماه",
    },
    {
        id: 7,
        title: "مهر ماه",
    },
    {
        id: 8,
        title: "آبان ماه",
    },
    {
        id: 9,
        title: "آذر ماه",
    },
    {
        id: 10,
        title: "دی ماه",
    },
    {
        id: 11,
        title: "بهمن ماه",
    },
    {
        id: 12,
        title: "اسفند ماه",
    },
];

export enum FINANCIAL_PERIOD_STATUS {
    open = 1,
    closed = 2,
}
